import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 464v-272h448v272c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48zM320 268v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM320 396v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM192 268v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM192 396v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM64 268v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM64 396v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12zM400 64c26.5 0 48 21.5 48 48v48h-448v-48c0-26.5 21.5-48 48-48h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h128v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-alt.js
// module id = 1131
// module chunks = 0